export const SELECTOR_EMPTY_MESSAGE = "No records found";
